<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}资产验收</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="验收范围" prop="no">
              <el-radio-group :disabled="!editMode" v-model="form.checkRange" @change="rangeChange">
                <el-radio v-for="item in AcceptRangeOptions" :label="item.id" :key="item.id">{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="范围详情">
              <el-select :disabled="!editMode" v-if="form.checkRange == 1" v-model="form.supplierName" style="width: 90%" filterable placeholder="请选择范围详情" :filter-method="(value)=> getSuppliers(value, 1)" @change="supplierChange">
                <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-select :disabled="!editMode" v-if="form.checkRange == 0" v-model="form.contractNo" style="width: 90%" filterable placeholder="请选择范围详情" :filter-method="getContracts" @change="contractChange">
                <el-option v-for="item in STATIC_Contracts" :key="item.id" :label="item.contractNo + ' ' + item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产验收单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成资产验收单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属部门" prop="ownerDeptName">
                <el-input v-model="form.ownerDeptName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="资产验收人" prop="checkName">
                <el-select :disabled="!editMode" v-model="form.checkName" style="width: 90%" filterable placeholder="请选择资产验收人" :filter-method="getUsers" @change="checkUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购人员" prop="purchaseUserName">
                <el-select :disabled="!editMode" v-model="form.purchaseUserName" style="width: 90%" filterable placeholder="请选择采购人员" :filter-method="getUsers" @change="purchaseUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证明人" prop="witnessName">
                <el-select :disabled="!editMode" v-model="form.witnessName" style="width: 90%" filterable placeholder="请选择证明人" :filter-method="getUsers" @change="witnessChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收状态" prop="supplierName">
                <el-select disabled v-model="form.state" placeholder="请选择验收状态" style="width: 90%">
                  <el-option v-for="item in AcceptInStockOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="总数量" prop="totalNumber">
                <el-input disabled v-model="form.totalNumber" placeholder="系统自动带出总数量" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input disabled v-model="form.totalAmount" placeholder="系统自动带出总金额" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="验收情况" prop="checkDesc">
                <el-input :disabled="!editMode" v-model="form.checkDesc" placeholder="请填写验收情况" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">资产详细信息</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <el-table-column show-overflow-tooltip label="资产编码" align="center" width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" width="130" prop="fixedAssetName" />
            <el-table-column show-overflow-tooltip label="规格型号" align="center" width="130" prop="specName" />
            <el-table-column show-overflow-tooltip label="生产厂家" align="center" width="130" prop="manufacturerName" />
            <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" width="100" prop="brandName" /> -->
            <el-table-column show-overflow-tooltip label="单位" align="center" width="80" prop="unitName" />
            <el-table-column show-overflow-tooltip label="单价" align="center" width="80" prop="price" />
            <el-table-column show-overflow-tooltip label="数量" align="center" width="80" prop="number" />
            <el-table-column show-overflow-tooltip label="金额" align="center" width="100" prop="amount" />
            <el-table-column show-overflow-tooltip label="注册证号" align="center" width="120" prop="certNo" />
            <el-table-column show-overflow-tooltip label="产地类型" align="center" width="80" prop="productionPlaceName" />
            <!-- <el-table-column show-overflow-tooltip label="合同编号" align="center" width="130" prop="contractNo" /> -->

            <el-table-column label="验收通过资产总数" align="center" width="180" prop="passNumber" />
            <el-table-column label="验收通过资产总金额" align="center" width="180" prop="passAmount" />
            <el-table-column label="验收未通过资产总数" align="center" width="180" prop="unPassNumber" />
            <el-table-column label="验收未通过资产总金额" align="center" width="180" prop="unPassAmount" />

            <el-table-column label="实物与合同清单是否一致" align="center" width="180" prop="isIdentical">
              <template slot-scope="scope">
                <span>{{ getBoolName(scope.row.isIdentical) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="包装合格" align="center" width="80" prop="isPackOk">
              <template slot-scope="scope">
                <span>{{ getBoolName(scope.row.isPackOk) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="验收合格" align="center" width="80" prop="isCheckOk">
              <template slot-scope="scope">
                <span>{{ getBoolName(scope.row.isCheckOk) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="验收情况" align="center" width="120" prop="remark" />
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编码" prop="fixedAssetNo">
                <SelectTable v-if="form.checkRange == 0" :disabled="!editMode" :columns="contractDetailAssetColumns" :placeholder="'请选择资产编码'" :innerName="childForm.fixedAssetNo" :dataList="assetList" @change="selectAsset" />
                <SelectTable v-else :disabled="!editMode" :columns="assetColumns" :placeholder="'请选择资产编码'" :innerName="childForm.fixedAssetNo" :dataList="assetList" @change="selectAsset" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="name">
                <el-input disabled v-model="childForm.fixedAssetName" placeholder="系统自动带出资产名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <!-- <el-input :disabled="!(editMode && form.checkRange!=0)" v-model="childForm.price" placeholder="系统自动带出单价" /> -->
                <el-input-number :disabled="!(editMode && form.checkRange != 0)" v-model="childForm.price" :min="0" :precision="4" :controls="false" placeholder="系统自动带出单价" @change="childNumberChange" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="1" :precision="2" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="childForm.number" placeholder="请填写数量" @change="childNumberChange" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="金额" prop="amount">
                <el-input disabled v-model="childForm.amount" placeholder="系统自动带出金额" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <!-- <el-select :disabled="!editMode" v-model="childForm.manufacturerName" style="width: 100%" filterable placeholder="请选择生产厂家" :filter-method="getManufacturers" @change="manufacturerChange">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select> -->
                <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="注册证" prop="certNo">
                <el-select :disabled="!editMode" v-model="childForm.certNo" style="width: 100%" clearable filterable placeholder="请选择注册证" :filter-method="getRegistCerts" @change="certChange">
                  <el-option v-for="item in STATIC_ManufacturerProductRegistCerts" :key="item.id" :label="item.no" :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-input
                  disabled
                  v-model="childForm.certNo"
                  placeholder="系统自动带出注册证"
                /> -->
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="合同编号" prop="contractNo">
                <el-input disabled v-model="childForm.contractNo" placeholder="系统自动带出合同编号" />
              </el-form-item>
            </el-col> -->
          </el-row>

          <span style="margin-left: 10px">验收状态</span>

          <el-row>
            <el-col :span="6">
              <el-form-item label="验收通过资产总数" prop="passNumber">
                <el-input-number :disabled="!editMode" v-model="childForm.passNumber" :min="0" :precision="2" :controls="false" placeholder="请填写验收通过资产总数" @change="passNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="childForm.passNumber" placeholder="请填写验收通过资产总数" @change="passNumberChange" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收通过资产总金额" prop="passAmount">
                <el-input-number disabled v-model="childForm.passAmount" :min="0" :precision="4" :controls="false" placeholder="系统自动带出验收通过资产总金额" style="width: 100%"></el-input-number>
                <!-- <el-input disabled v-model="childForm.passAmount" placeholder="系统自动带出验收通过资产总金额" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收未通过资产总数" prop="unPassNumber">
                <el-input-number disabled v-model="childForm.unPassNumber" :min="0" :precision="2" :controls="false" placeholder="系统自动带出验收未通过资产总数" style="width: 100%"></el-input-number>
                <!-- <el-input disabled v-model="childForm.unPassNumber" placeholder="系统自动带出验收未通过资产总数" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收未通过资产总金额" prop="unPassAmount">
                <el-input-number disabled v-model="childForm.unPassAmount" :min="0" :precision="4" :controls="false" placeholder="系统自动带出验收未通过资产总金额" style="width: 100%"></el-input-number>
                <!-- <el-input disabled v-model="childForm.unPassAmount" placeholder="系统自动带出验收未通过资产总金额" /> -->
              </el-form-item>
            </el-col>
          </el-row>

          <span style="margin-left: 10px; font-weight: bold">验收信息</span>

          <el-row>
            <el-col :span="6">
              <el-form-item label="实物与合同清单是否一致" prop="isIdentical">
                <el-select :disabled="!editMode" v-model="childForm.isIdentical" placeholder="请选择状态" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="包装合格" prop="isPackOk">
                <el-select :disabled="!editMode" v-model="childForm.isPackOk" placeholder="请选择状态" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验收合格" prop="isCheckOk">
                <el-select :disabled="!editMode" v-model="childForm.isCheckOk" placeholder="请选择状态" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="验收情况" prop="remark">
                <el-input :disabled="!editMode" v-model="childForm.remark" placeholder="请填写验收情况" resize="none" type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="资产启用状态">
                <el-switch :disabled="!editMode" v-model="childForm.state" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
                </el-switch>
                <span v-if="childForm.state==1">启用</span>
                <span v-else>禁用</span>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetAssetCheckById,
  SaveAssetCheck,
  // GetContractsBySupplierId,
  GetContractById,
  RejectAssetCheck,
} from "@/api";
import {
  AcceptRangeOptions,
  AcceptInStockOptions,
  WhetherOptions,
} from "@/enum";
// import Address from '@/components/address';
// import ElImageViewer from '@/components/elImageViewer'
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    // ElImageViewer
  },
  data () {
    return {
      form: {},
      AcceptRangeOptions: AcceptRangeOptions,
      AcceptInStockOptions: AcceptInStockOptions,
      WhetherOptions: WhetherOptions,
      rules: {
        checkName: [
          { required: true, message: "验收人不能为空", trigger: "blur" },
        ],
        purchaseUserName: [
          { required: true, message: "采购人员不能为空", trigger: "blur" },
        ],
        witnessName: [
          { required: true, message: "证明人不能为空", trigger: "blur" },
        ],
        checkDesc: [
          { required: true, message: "验收情况不能为空", trigger: "blur" },
        ],
      },
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编码不能为空", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          { required: true, validator: this.validateNumber, tigger: "blur" },
        ],
        passNumber: [
          {
            required: true,
            message: "验收通过资产总数不能为空",
            trigger: "blur",
          },
        ],
        price: [{ required: true, message: "单价不能为空", trigger: "blur" }],
      },
      assetList: [],
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      childForm: {},
      reject: RejectAssetCheck,

      defaultProps: {
        children: "childs",
        label: "name",
      },
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getUsers("");
    this.getSuppliers("", 1);
    this.getContracts("");
    this.getRegistCerts("");
    this.getManufacturers("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetAssetCheckById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.getFixedAssetList("");

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveAssetCheck(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        checkRange: 0,
        name: "",
        state: 0,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        fixedAssetNo: "",
        name: "",
        number: "",
        price: 0,
        amount: 0,
        isIdentical: 1,
        isPackOk: 1,
        isCheckOk: 1,
        remark: "",
        passNumber: 0,
        passAmount: 0,
        unPassNumber: 0,
        unPassAmount: 0,
        state: 1,
        certId: "",
        certNo: "",
        manufacturerId: "",
        manufacturerName: "",
        brandId: "",
        brandName: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);

      // this.showDetailColumns()
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.assetId == this.childForm.assetId
        );

        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前资产信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前资产信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      this.autoAmount();

      if (
        this.childForm.passNumber + this.childForm.unPassNumber !=
        this.childForm.number
      ) {
        this.childForm.passNumber =
          this.childForm.number - this.childForm.unPassNumber;
        this.childForm.passAmount =
          this.childForm.passNumber * this.childForm.price;
        this.childForm.unPassAmount =
          this.childForm.unPassNumber * this.childForm.price;
      }
    },
    passNumberChange () {
      this.childForm.passAmount =
        this.childForm.passNumber * this.childForm.price;
      this.childForm.unPassNumber =
        this.childForm.number - this.childForm.passNumber;
      this.childForm.unPassAmount =
        this.childForm.unPassNumber * this.childForm.price;
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
    },

    // change event
    selectAsset (row) {
      this.childForm = Object.assign(this.childForm, row, {
        fixedAssetNo: row.no,
        fixedAssetName: row.name,
        assetId: row.id,
        remark: "",
        id: 0,
        stockState: row.state,
        // contractId: row.parentId,
        // contractNo: row.contractNo
      });

      if (this.form.checkRange == 0) {
        this.childForm.notCheckedNumber = row.number - row.checkedNumber;
        this.childForm.number = this.childForm.notCheckedNumber;
        // this.childForm.amount = (row.number - row.checkedNumber) * row.price
      } else {
        this.childForm.number = 1;
        this.childForm.price = 0;
      }

      this.autoAmount();
      this.childForm.passNumber = this.childForm.number;
      this.childForm.passAmount = this.childForm.amount;
      this.getRegistCerts();
    },
    checkUserChange (val) {
      this.form.checkUserId = val;
    },
    purchaseUserChange (val) {
      this.form.purchaseUserId = val;
    },
    witnessChange (val) {
      this.form.witness = val;
    },
    contractChange (val, isClearDetails) {
      this.form.contractId = val;
      GetContractById({ id: val }).then((res) => {
        let details = res.returnData.details;
        this.form.supplierId = res.returnData.supplierId;
        if (details && details.length > 0) {
          details.map((item) => {
            item.id = item.assetId;
            item.name = item.fixedAssetName;
            item.no = item.fixedAssetNo;

            return item;
          });

          this.assetList = details;
        } else {
          this.assetList = [];
        }
        if (!isClearDetails) {
          this.form.details = [];
        }
      });
    },
    supplierChange (val, isClearDetails) {
      this.form.supplierId = val;
      // GetContractsBySupplierId({ supplierId: this.form.supplierId })
      //   .then(res => {
      //     if (!isClearDetails) {
      //       this.form.details = []
      //     }

      //     this.assetList = res.returnData.data
      //   })

      // this.getFixedAssets({ keyWord, state: 1 })
    },
    rangeChange (val) {
      if (val == 1) {
        this.form.contractId = "";
        this.form.contractNo = "";

        // 供应商可以选择所有资产
        this.getFixedAssetList("");
      } else {
        this.form.supplierId = "";
        this.form.supplierName = "";

        this.assetList = [];
        this.form.details = [];
      }
    },
    manufacturerChange (val) {
      this.childForm.manufacturerId = val;
      let item = this.STATIC_Manufacturers.find((e) => e.id == val);
      if (item) {
        this.childForm.manufacturerName = item.name;
      }
    },
    certChange (val) {
      this.childForm.certId = val;
      let item = this.STATIC_ProductRegistCerts.find((e) => e.id == val);
      if (item) {
        this.childForm.manufacturerId = item.manufacturerId;
        this.childForm.manufacturerName = item.manufacturerName;
      }
    },

    getFixedAssetList (keyWord) {
      if (this.form.checkRange == 0) {
        this.contractChange(this.form.contractId, true);
      } else {
        this.getFixedAssetByQuerys({ keyWord, state: 1 }).then((res) => {
          this.assetList = res;
        });
      }
    },

    // 其他
    validateNumber (rule, value, callback) {
      if (
        this.form.checkRange == 0 &&
        value > this.childForm.notCheckedNumber
      ) {
        callback(
          new Error(
            `验收数量不能大于未验收数量(${this.childForm.notCheckedNumber})`
          )
        );
      } else {
        callback();
      }
    },
    getRegistCerts (val) {
      this.getProductRegistCertsByManufacturer(
        this.childForm.manufacturerId,
        val
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
